import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { lastValueFrom, Observable } from 'rxjs';
import { Car } from '@cl/shared/models/cars/car.model';
import { CarFilter } from '@cl/shared/models/cars/car-filter.model';
import { BaseServiceWithFilter } from '.';

@Injectable({
    providedIn: 'root',
})
export class CarsService extends BaseServiceWithFilter<Car, CarFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/cars/');
    }

    getUsersCars(): Observable<CommandResult<Car[]>> {
        return this.httpClient.get<CommandResult<Car[]>>(`${this.baseApiUrl}get-users-cars`);
    }

    // HR-Orders formas auto: formas uzņēmuma aktīvie auto lietotāja VIEW struktūrvienību tvērumā;
    // izvēlēto darbinieku struktūrvienības nosaka tikai noklusēto auto.
    async getForHrOrder(companyId: number, selectedDepartmentIds: number[]): Promise<Car[]> {
        let params = new HttpParams().append('companyId', `${companyId}`);

        selectedDepartmentIds.forEach((id) => (params = params.append('selectedDepartmentIds', `${id}`)));

        const result = await lastValueFrom(this.httpClient.get<CommandResult<Car[]>>(`${this.baseApiUrl}for-hr-order`, { params }));

        return result?.data ?? [];
    }

    toString(object: Car): string {
        return `${object.mark} (${object.plateNumber})`;
    }

    toStringWithDriver(car: Car): string {
        return `${car.mark} (${car.plateNumber}) ${car.user?.name ?? ''} ${car.user?.surname ?? ''}`;
    }
}
